import React from 'react';
import { useQuery, useQueryClient } from '@tanstack/react-query';
import { AlertTriangle, CheckCircle, Wrench } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { format } from 'date-fns';
import { ptBR } from 'date-fns/locale';
import api from '../../services/api';

export default function EstoqueAlertas() {
  const navigate = useNavigate();
  const qc = useQueryClient();
  const { data, isLoading } = useQuery({
    queryKey: ['estoque-alertas'],
    queryFn: () => api.get('/estoque/alertas').then(r => r.data.data),
    refetchInterval: 30000,
  });

  async function resolver(id) {
    await api.put(`/estoque/alertas/${id}/resolver`, { resolvido_por: 'Usuário' });
    qc.invalidateQueries(['estoque-alertas']);
    qc.invalidateQueries(['estoque-dashboard']);
  }

  const alertas = data || [];

  return (
    <div className="p-6 max-w-4xl mx-auto space-y-4">
      <div className="flex items-center gap-3">
        <AlertTriangle size={24} className="text-yellow-500" />
        <h1 className="text-2xl font-bold text-gray-800">Manutenções Preventivas</h1>
        {alertas.length > 0 && (
          <span className="bg-red-100 text-red-600 text-xs font-bold px-2 py-0.5 rounded-full">{alertas.length}</span>
        )}
      </div>

      {isLoading ? (
        <p className="text-gray-400 text-sm">Carregando...</p>
      ) : alertas.length === 0 ? (
        <div className="bg-white rounded-xl shadow p-12 flex flex-col items-center gap-3">
          <CheckCircle size={48} className="text-green-400" />
          <p className="text-gray-500 font-medium">Nenhum alerta de manutenção pendente</p>
          <p className="text-gray-400 text-sm">Todos os itens estão em dia!</p>
        </div>
      ) : (
        <div className="space-y-3">
          {alertas.map(a => (
            <div key={a.id} className="bg-white rounded-xl shadow border-l-4 border-yellow-400 p-4 flex items-start justify-between gap-4">
              <div className="flex items-start gap-3 flex-1 min-w-0">
                <div className="w-10 h-10 bg-yellow-100 rounded-xl flex items-center justify-center flex-shrink-0">
                  <Wrench size={18} className="text-yellow-600" />
                </div>
                <div className="min-w-0">
                  <div className="flex items-center gap-2">
                    <p className="font-semibold text-gray-800 truncate">{a.item_nome}</p>
                    <span className="font-mono text-xs text-gray-400 flex-shrink-0">{a.codigo}</span>
                  </div>
                  {a.categoria_nome && <p className="text-xs text-gray-500">{a.categoria_nome} · {a.obra_atual || '—'}</p>}
                  <p className="text-sm text-gray-600 mt-1">{a.mensagem}</p>
                  <p className="text-xs text-gray-400 mt-1">
                    Alerta criado em {format(new Date(a.created_at), "dd/MM/yyyy", { locale: ptBR })}
                  </p>
                </div>
              </div>
              <div className="flex gap-2 flex-shrink-0">
                <button onClick={() => navigate(`/estoque/itens/${a.item_id}`)}
                  className="text-xs px-3 py-1.5 border border-gray-200 rounded-xl hover:bg-gray-50 text-gray-700 font-medium">
                  Ver item
                </button>
                <button onClick={() => resolver(a.id)}
                  className="text-xs px-3 py-1.5 bg-green-600 text-white rounded-xl hover:bg-green-700 font-medium">
                  Resolver
                </button>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
